import { render, staticRenderFns } from "./assignLead.vue?vue&type=template&id=054bcfb0"
import script from "./assignLead.vue?vue&type=script&lang=js"
export * from "./assignLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports